import { ConsoleLogger, LogLevel } from "amazon-chime-sdk-js";
import { DeviceLabels } from "amazon-chime-sdk-component-library-react";
import "./polyfills";

// Initialize the logger
// export const logger = new ConsoleLogger("ChimeSDK", LogLevel.INFO);
// @todo restore
export const logger = {
  info: (a: any) => console.info(a),
  warn: (a: any) => console.warn(a),
  error: (a: any) => console.error(a),
};

// Default meeting configuration
export const defaultMeetingConfig = {
  simulcastEnabled: false,
  logger,
  deviceLabels: DeviceLabels.AudioAndVideo,
  enableWebAudio: true,
  skipDeviceSelection: false,
};

// Initialize the SDK
export const initializeChimeSDK = () => {};
